export default [
  {
    path: '/gurudwara/list',
    name: 'gurudwara-list',
    component: () => import('@/views/gurudwara/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Gurudwara List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Gurudwara' }, { title: 'Gurudwara List', active: true }],
      permissions: ['gurudwara_list']
    }
  },
  {
    path: '/gurudwara/add',
    name: 'create-gurudwara',
    component: () => import('@/views/gurudwara/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Gurudwara',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Add Gurudwara', active: true }
      ],
      permissions: ['gurudwara_create']
    }
  },
  // {
  //   path: '/gurudwara/add-v1',
  //   name: 'create-gurudwara',
  //   component: () => import('@/views/gurudwara/add.vue'),
  //   meta: {
  //     allowAnonymous: false,
  //     pageTitle: 'Add Gurudwara',
  //     parent: 'GurudwaraList',
  //     breadcrumb: [
  //       { title: 'Dashboard', url: '/dashboard' },
  //       { title: 'Gurudwara', url: '/gurudwara/list' },
  //       { title: 'Add Gurudwara', active: true }
  //     ],
  //     permissions: [GURUDWARA_ADD]
  //   }
  // },
  // {
  //   path: '/gurudwara/test',
  //   name: 'test-gurudwara',
  //   component: () => import('@/views/gurudwara/test.vue'),
  //   meta: {
  //     allowAnonymous: false,
  //     pageTitle: 'Add Gurudwara',
  //     parent: 'GurudwaraList',
  //     breadcrumb: [
  //       { title: 'Dashboard', url: '/dashboard' },
  //       { title: 'Gurudwara', url: '/gurudwara/list' },
  //       { title: 'Add Gurudwara', active: true }
  //     ]
  //   }
  // },
  {
    path: '/gurudwara/:id/edit',
    name: 'edit-gurudwara',
    component: () => import('@/views/gurudwara/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Gurudwara',
      parent: 'GurudwaraList',
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/dashboard' },
      //   { title: 'Gurudwara', url: '/gurudwara/list' },
      //   { title: 'Edit Gurudwara', active: true }
      // ],
      permissions: ['gurudwara_edit', 'gurudwara_view']
    }
  },
  {
    path: '/gurudwara/:id/service-req-list',
    name: 'service-req-list',
    component: () => import('@/views/gurudwara/requests.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Service Request List',
      parent: 'GurudwaraList',
      breadcrumb: [
        // { title: 'Dashboard', url: '/dashboard' },
        // { title: 'Gurudwara', url: '/gurudwara/list' },
        // { title: 'Services', active: true }
      ],
      permissions: ['service_request_list']
    }
  },
  {
    path: '/gurudwara/:id/gurudwara-admin-list',
    name: 'gurudwara-admin-list',
    component: () => import('@/views/gurudwara/gurudwara-admin.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Admin List',
      parent: 'GurudwaraList',
      breadcrumb: [
        // { title: 'Dashboard', url: '/dashboard' },
        // { title: 'Gurudwara', url: '/gurudwara/list' },
        // { title: 'Admin List', active: true }
      ],
      permissions: ['gurudwara_admin_list']
    }
  },
  {
    path: '/gurudwara/sarai/bookings',
    name: 'all-sarai-bookings',
    component: () => import('@/views/gurudwara/sarai/SaraiBookings.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sarai Bookings',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Sarai Bookings', active: true }
      ],
      permissions: ['stay_view', 'stay_edit']
    }
  },
  {
    path: '/gurudwara/service/bookings',
    name: 'all-service-bookings',
    component: () => import('@/views/gurudwara/service/ServiceBookings.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'All Bookings',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Service Bookings', active: true }
      ],
      permissions: [
        'available_service_list',
        'available_service_view',
        'available_service_edit',
        'gurudwara_service_booking_view',
        'gurudwara_view',
        'gurudwara_edit'
      ]
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/sarai/bookings',
    name: 'sarai-bookings',
    component: () => import('@/views/gurudwara/sarai/SaraiBookings.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sarai Bookings',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Sarai Bookings', active: true }
      ],
      permissions: ['stay_view', 'stay_edit']
    }
  },
  {
    path: '/gurudwara/:id/service/bookings',
    name: 'service-bookings',
    component: () => import('@/views/gurudwara/service/ServiceBookings.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'All Bookings',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Service Bookings', active: true }
      ],
      permissions: [
        'available_service_list',
        'available_service_view',
        'available_service_edit',
        'gurudwara_service_booking_view',
        'gurudwara_view',
        'gurudwara_edit'
      ]
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/sarai/add',
    name: 'add-sarai',
    component: () => import('@/views/gurudwara/sarai/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Sarai',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Add Sarai', active: true }
      ],
      permissions: ['stay_edit', 'stay_view']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/sarai/:saraiId/edit',
    name: 'edit-sarai',
    component: () => import('@/views/gurudwara/sarai/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Sarai',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Edit Sarai', active: true }
      ],
      permissions: ['stay_edit', 'stay_view']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/sarai/:saraiId/dashboard',
    name: 'sarai-dashboard',
    component: () => import('@/views/gurudwara/sarai/SaraiDashboard.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Sarai Dashboard',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Sarai Dashboard', active: true }
      ],
      permissions: ['stay_edit', 'stay_view']
    }
  },
  {
    path: '/gurudwara/:gurudwaraId/sarai/:saraiId/rooms',
    name: 'sarai-room-management',
    component: () => import('@/views/gurudwara/sarai/RoomManagement.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Room Management',
      parent: 'GurudwaraList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Gurudwara', url: '/gurudwara/list' },
        { title: 'Room Management', active: true }
      ],
      permissions: ['stay_edit', 'stay_view']
    }
  }
]
